import ErrorBase from './ErrorBase'

class RuntimeError extends ErrorBase {
  constructor(message: string) {
    super({ code: '320200', message, type: 'RuntimeError' })
  }
}

export default RuntimeError
